export default {"src":"/accounts/_next/static/media/plusIcon.58f19249.svg","height":37,"width":38,"blurWidth":0,"blurHeight":0};